import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Lecturers } from "../../components/Lecturers/Lectuerers";
import Table from "react-bootstrap/Table";

import {
  academicStaff,
  lecturers,
  nonAcademicStaff,
  others,
  staffList,
  nonAcademicstaffList,
} from "../../TextData";
import "./directory.scss";
export const Directory = () => {
  const [activeIndex, setActiveIndex] = useState(1);
  const handleClick = (index) => setActiveIndex(index);
  const checkActive = (index, className) =>
    activeIndex === index ? className : "";
  const [state, setState] = useState({
    query: "",
    list: lecturers,
    list2: academicStaff,
    list3: nonAcademicStaff,
    list4: others,
  });
  const [data, setData] = useState([]);

  return (
    <>
      <div className="directory-page">
        {/* <center>
          <h1>Our Directory</h1>
        </center> */}
        <div className="flexy flexyM offset-md-5 mt5">
          {" "}
          <Link to={"/"} className="home-link">
            HOME
          </Link>
          <span>
            <i class="icofont-rounded-right"></i>
          </span>
          <h6>About</h6>
        </div>
      </div>
      <div className="directory-tab ">
        {" "}
        <div className="tabs offset-md-4">
          <button
            className={`tab ${checkActive(1, "active2")}`}
            onClick={() => handleClick(1)}
          >
            Directors
          </button>
          <button
            className={`tab ${checkActive(2, "active2")}`}
            onClick={() => handleClick(2)}
            style={{ marginLeft: "20px" }}
          >
            Professors
          </button>
          <button
            className={`tab ${checkActive(3, "active2")}`}
            onClick={() => handleClick(3)}
            style={{ marginLeft: "20px" }}
          >
            Doctors
          </button>
          <button
            className={`tab ${checkActive(4, "active2")}`}
            onClick={() => handleClick(4)}
            style={{ marginLeft: "20px" }}
          >
            Others
          </button>
        </div>
        <div className="panels">
          <div className={`panel ${checkActive(1, "active2")}`}>
            <div className="row row-cols-2 row-cols-lg-4  g-lg-2 col-md-8 offset-md-2 mt8 mobile-padding">
              {state.list.map((data, index) => (
                <Lecturers data={data} />
              ))}
            </div>
          </div>
          <div className={`panel ${checkActive(2, "active2")}`}>
            {" "}
            <div className="row row-cols-2 row-cols-lg-4  g-lg-2 col-md-8 offset-md-2 mt8">
              {state.list2.map((data, index) => (
                <Lecturers data={data} />
              ))}
            </div>
          </div>
          <div className={`panel ${checkActive(3, "active2")}`}>
            {" "}
            <div className="row row-cols-2 row-cols-lg-4  g-lg-2 col-md-8 offset-md-2 mt8">
              {state.list3.map((data, index) => (
                <Lecturers data={data} />
              ))}
            </div>
          </div>{" "}
          <div className={`panel ${checkActive(4, "active2")}`}>
            {" "}
            <div className="row row-cols-2 row-cols-lg-4  g-lg-2 col-md-8 offset-md-2 mt8">
              {state.list4.map((data, index) => (
                <Lecturers data={data} />
              ))}
            </div>
          </div>
          <div className="col-md-8 offset-md-2  mt6">
            <center>
              <h3>TECHNICAL/LABORATORY STAFF</h3>
              <p>
                The Department has, fourteen technical staff and seven
                administrative staff as listed below.
              </p>
            </center>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>S/N</th>
                  <th>Name</th>
                  <th>Qualification</th>
                  <th>Designation</th>
                  <th>Specialization</th>
                </tr>{" "}
              </thead>
              <tbody>
                {staffList.map((item, index) => (
                  <tr>
                    <td>{item.num}</td>
                    <td>{item.name}</td>

                    <td>{item.qualification}</td>
                    <td>{item.role}</td>
                    <td>{item.specialization}</td>
                  </tr>
                ))}
              </tbody>
            </Table>{" "}
            <br />
            <br />
            <br />
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>S/N</th>
                  <th>Name</th>
                  <th>Qualification</th>
                  <th>Designation</th>
                </tr>{" "}
              </thead>
              <tbody>
                {nonAcademicstaffList.map((item, index) => (
                  <tr>
                    <td>{item.num}</td>
                    <td>{item.name}</td>

                    <td>{item.qualification}</td>
                    <td>{item.role}</td>
                    <td>{item.specialization}</td>
                  </tr>
                ))}
              </tbody>
            </Table>{" "}
          </div>
        </div>
      </div>
    </>
  );
};
